import React, { useState } from 'react';
import { Input } from './ui/input';
import { Checkbox } from './ui/checkbox';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from './ui/select';
import * as api from '../services/api';

const LoginPage = ({ onLogin }) => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [rememberMe, setRememberMe] = useState(false);
  const [language, setLanguage] = useState('es');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setIsLoading(true);

    try {
      // Try API login
      const response = await api.login(username, password);
      const user = response.data.user;
      
      if (rememberMe) {
        localStorage.setItem('rememberedUser', username);
      }
      onLogin(user);
    } catch (error) {
      console.error('Login error:', error);
      const errorMessage = error.response?.data?.detail || 
        (language === 'es' ? 'Usuario o contraseña incorrectos' : 'Invalid username or password');
      setError(errorMessage);
    }
    setIsLoading(false);
  };

  return (
    <div className="min-h-screen bg-[#e8e8e8] flex flex-col">
      {/* Header with Logo */}
      <header className="w-full flex justify-end p-6">
        <div className="flex flex-col items-center">
          <img 
            src="https://customer-assets.emergentagent.com/job_infinito-crm/artifacts/ra46uumc_Logo%20Clear%202026.png" 
            alt="Infinito Television"
            className="h-16 object-contain"
          />
        </div>
      </header>

      {/* Login Form */}
      <main className="flex-1 flex items-center justify-center px-4 -mt-20">
        <div className="bg-white rounded-lg shadow-sm p-8 w-full max-w-md">
          <div className="flex items-center justify-between mb-6">
            <h1 className="text-2xl font-semibold text-[#333] italic">
              {language === 'es' ? 'Iniciar Sesión' : 'Login'}
            </h1>
            <Select value={language} onValueChange={setLanguage}>
              <SelectTrigger className="w-[100px] h-8 text-sm border-gray-300">
                <SelectValue />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="es">Español</SelectItem>
                <SelectItem value="en">English</SelectItem>
              </SelectContent>
            </Select>
          </div>

          <form onSubmit={handleSubmit} className="space-y-5">
            <div>
              <label className="block text-sm text-[#333] mb-2">
                {language === 'es' ? 'Usuario' : 'Username'}
              </label>
              <Input
                type="text"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                className="w-full h-11 border-gray-300 rounded focus:border-[#D4A843] focus:ring-[#D4A843]"
                placeholder={language === 'es' ? 'Ingrese su usuario' : 'Enter your username'}
              />
            </div>

            <div>
              <label className="block text-sm text-[#333] mb-2">
                {language === 'es' ? 'Contraseña' : 'Password'}
              </label>
              <Input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="w-full h-11 border-gray-300 rounded focus:border-[#D4A843] focus:ring-[#D4A843]"
                placeholder={language === 'es' ? 'Ingrese su contraseña' : 'Enter your password'}
              />
            </div>

            {error && (
              <p className="text-red-500 text-sm">{error}</p>
            )}

            <div className="flex items-center space-x-2">
              <Checkbox
                id="remember"
                checked={rememberMe}
                onCheckedChange={setRememberMe}
                className="border-gray-300"
              />
              <label htmlFor="remember" className="text-sm text-[#333] cursor-pointer">
                {language === 'es' ? 'Mantener sesión iniciada' : 'Keep me logged in'}
              </label>
            </div>

            <button
              type="submit"
              disabled={isLoading}
              className="w-full h-11 bg-[#6b7280] hover:bg-[#5b6270] text-white rounded transition-colors duration-200 font-medium disabled:opacity-70"
            >
              {isLoading ? (
                <span className="flex items-center justify-center">
                  <svg className="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                  </svg>
                  {language === 'es' ? 'Cargando...' : 'Loading...'}
                </span>
              ) : (
                language === 'es' ? 'Entrar' : 'Login'
              )}
            </button>
          </form>
        </div>
      </main>
    </div>
  );
};

export default LoginPage;
